// adtribute.io tracking snippet: vendor code, kept as delivered apart from pgxAfterLoad (not linted
// or formatted). This is adtribute's version for multi-part TLDs (co.uk, com.br). On every other
// store domain it finds the same cookie domain as their default snippet, so all stores use it.
(() => {
  if (window._adbs && window._adbs.scriptLoaded) return;
  var e, t;
  ((window._adbq = window._adbq || []),
    (window._adbs = window._adbs || {
      organizationId: 'cm0gf8uc8000022p0uii8os82',
      subDomain: 'pergolux',
      environment: 'prod',
    }),
    (window._adbs.topLevelDomain =
      ((t = (e = window.location.host.split('.')).slice(-2).join('.')),
      [
        'com.br',
        'co.uk',
        'org.uk',
        'gov.uk',
        'edu.au',
        'ac.uk',
        'net.au',
        'com.au',
        'gov.au',
        'mil.br',
      ].includes(t)
        ? e.slice(-3).join('.')
        : t)));
  let o = `https://${window._adbs.subDomain}.${window._adbs.topLevelDomain}/${window._adbs.organizationId}/client.js`,
    r = `https://collector.api.adtribute.io/${window._adbs.organizationId}/client.js`,
    i = '_adbq',
    a = (() => {
      var e = '__storage_test__';
      try {
        return (localStorage.setItem(e, e), localStorage.removeItem(e), !0);
      } catch (e) {
        return !1;
      }
    })(),
    n = () => {
      let e;
      return (e =
        (e = a ? localStorage.getItem(i) : e) ||
        ((e) => {
          try {
            var t = e + '=',
              o = document.cookie.split(';');
            for (let e = 0; e < o.length; e++) {
              let r = o[e];
              for (; ' ' === r.charAt(0); ) r = r.substring(1);
              if (0 === r.indexOf(t)) return r.substring(6, r.length);
            }
          } catch (e) {
            console.error(e);
          }
        })(i))
        ? JSON.parse(e)
        : [];
    },
    d = (e) => {
      a
        ? localStorage.setItem(i, JSON.stringify(e))
        : ((e, t) => {
            try {
              document.cookie = `${e}=${t}; expires=${new Date(new Date().getTime() + 63072e6).toUTCString()}; domain=.${window._adbs.topLevelDomain}; path=/; secure;`;
            } catch (e) {
              console.error(e);
            }
          })(i, JSON.stringify(e));
    },
    s = () => {
      var e = document.createElement('script'),
        t =
          ((e.type = 'text/javascript'),
          (e.src = window._adbs.scriptSrc),
          (e.async = !0),
          (e.onerror = () => {
            var e;
            window._adbs.scriptSrc === o
              ? ((window._adbs.scriptSrc = r), s())
              : (c++,
                (e = 1e3 * Math.pow(2, c)),
                setTimeout(() => {
                  ((window._adbs.scriptSrc = o), s());
                }, e));
          }),
          document.getElementsByTagName('script')[0]);
      t.parentNode.insertBefore(e, t);
    },
    c =
      (n().forEach((e) => window._adbq.push(e)),
      window._adbq.push([
        'track',
        'web_event_pageview',
        {
          timestamp: new Date().toISOString(),
          page_title: document.title,
          page_url: window.location.href,
          referrer_url: document.referrer,
        },
      ]),
      Object.defineProperty(window._adbq, 'push', {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value(...e) {
          for (let r = 0, i = this.length, a = e.length; r < a; r++, i++)
            ((t = this[i] = e[r]), (o = void 0), (o = n()).push(t), d(o));
          var t, o;
        },
      }),
      d(window._adbq),
      0);
  ((window._adbs.scriptSrc = o), pgxAfterLoad(s), (window._adbs.scriptLoaded = !0));
})();
